<template>
  <div class="gray-back">
    <div class="mine-box-title">我的经历</div>
    <div class="mine-content">

      <div v-if="!loading" class="" style="height: 100%">
        <van-cell-group v-if="!row.cert.status && false">
          <van-cell is-link @click="$toast('正在建设中')" title="我的运动员资质" label="">
          </van-cell>
          <van-cell is-link @click="toJiaolian" title="我的教练员资质" :label="!row.cert.status ? '请先进行实名认证' : ''">
          </van-cell>
          <van-cell is-link @click="toCaipan" title="我的裁判员资质" :label="!row.cert.status ? '请先进行实名认证' : ''">
          </van-cell>
          <div style="height: 10px"></div>
        </van-cell-group>

        <div v-if="row.cert.status" class="cert-box">
          <img src="../../../assets/images/cha/bg-yundongyuan.png" @click="$message('正在建设中')" alt="">
          <img src="../../../assets/images/cha/bg-jiaolianyuan.png" @click="toJiaolian" alt="">
          <img src="../../../assets/images/cha/bg-caipanyuan.png" @click="toCaipan" alt="">
        </div>

        <div v-else style="text-align: center">
          <van-empty description="您还未实名认证，请认证后再查询"/>
          <el-button
              type="primary"
              size="normal" round v-rblink="{name: 'CertIndex'}">立即实名认证
          </el-button>
        </div>
        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

      </div>
    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.cert-box {
  /*margin: .2rem;*/
}

.cert-box img {
  width: 45%;
  cursor: pointer;
}


.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'MyExperience',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loading: true,
      saveLoading: false,
      loginShow: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      row: {
        danwei: {},
        cert: {}
      },
      formData: {},
    }
  },
  filters: {},
  mounted() {
    document.title = "我的经历";
    let that = this;
    this.fetch();
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },

    toJiaolian() {
      if (this.row.cert.status) {
        rbLink({
          name: 'UserSearchJiaolian'
        })
      } else {
        Toast('请先进行实名认证')
        setTimeout(function () {
          rbLink({
            name: 'CertIndex'
          })
        }, 200)
      }
    },

    toCaipan() {
      if (this.row.cert.status) {
        rbLink({
          name: 'UserSearchCaipan'
        })
      } else {
        Toast('请先进行实名认证')
        setTimeout(function () {
          rbLink({
            name: 'CertIndex'
          })
        }, 200)
      }
    },
    fetch() {
      let that = this;
      that.$api.post('/api/user/certindex', {}, (res) => {
        that.row = res.data;
        that.loading = false
      }, (res) => {
        that.loading = false
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// MyExperience.vue?a1a437d2